import React, { Component } from "react";
import { Icon } from "@iconify/react";
import { Modal } from "react-responsive-modal";
import Swal from "sweetalert2";
import { withNamespaces } from "react-i18next";

// Components
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";
import StringInput from "../../components/Input/StringInput/StringInput";
import DateScroller from "../../components/MobileAssets/DateScroller/DateScroller";
import EditMobileNo from "./MobileEditPage/EditMobileNo";
import EditEmailAddress from "./MobileEditPage/EditEmailAddress";
import EditPaymentPassword from "./MobileEditPage/EditPaymentPassword";
import EditLoginPassword from "./MobileEditPage/EditLoginPassword";
import EditSecurityAns from "./EditSecurityAns";
import BindingAuthenticator from "./BindingAuthenticator";
// import Authenticator from "./MobileEditPage/Authenticator";
export class MobilePersonalDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,

            showEditMobileNo: false,
            showEditEmailAddress: false,
            showDateSelect: false,
            showEditPaymentPass: false,
            showEditLoginPass: false,
            showEditSecurityAns: false,
            showAuthenticator: false,
        };
    }

    toggleEditRealNameModal = () => {
        this.setState({
            showModal: !this.state.showModal,
        });
    };

    updateRealName = (e) => {
        const { t } = this.props;
        e.preventDefault();
        Swal.fire({
            iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
            icon: "success",
            title: t("global.success"),
            text: t("profile.update-success"),
            showConfirmButton: true,
            customClass: {
                container: "swal-mobile-container sucess",
                icon: "swal-success-icon",
            },
        });
    };
    securityInfo = (props) => {
        return (
            <>
                <div>
                    <div className="input-group-col">
                        <div className="input-group right has-validation" onClick={props.onClick}>
                            <p className="form-control lh-lg text-slate-800">{props.title}</p>
                            <span className="input-group-text">
                                <Icon icon="uil:angle-right" />
                            </span>
                        </div>
                    </div>
                    <p className="mt-2 ms-3" style={{ fontSize: ".75rem", display: "list-item" }}>
                        {props.desc}
                    </p>
                </div>
            </>
        );
    };

    //**OPEN & CLOSE EDIT PAGE**
    toggleShowDateSelect = (e) => {
        this.setState({
            showDateSelect: !this.state.showDateSelect,
        });
    };
    toggleShowEditEmailAddress = () => {
        this.setState({
            showEditEmailAddress: !this.state.showEditEmailAddress,
        });
    };

    toggleShowEditMobileNo = (value) => {
        this.setState({
            showEditMobileNo: !this.state.showEditMobileNo,
            showEditPaymentPass: false
        });

        if(value === "forget_security_pin"){
            this.props.onForgetPaymentPasswordHandler();
        }
    };

    toggleShowEditPaymentPass = () => {
        this.setState({
            showEditPaymentPass: !this.state.showEditPaymentPass,
        });
    };

    toggleShowEditLoginPass = () => {
        this.setState({
            showEditLoginPass: !this.state.showEditLoginPass,
        });
    };

    toggleShowEditSecurityAns = () => {
        this.setState({
            showEditSecurityAns: !this.state.showEditSecurityAns,
        });
    };

    toggleShowAuthenticator = () => {
        this.setState({
            showAuthenticator: !this.state.showAuthenticator,
        });
    };

    //*********

    render() {
        const { t } = this.props;
        return (
            <>
                {this.state.showEditMobileNo && <EditMobileNo 
                  backToPersonalDetails={this.toggleShowEditMobileNo}
                  {...this.props}
                />}
                {this.state.showEditEmailAddress && <EditEmailAddress 
                    {...this.props}  
                    backToPersonalDetails={this.toggleShowEditEmailAddress}
                  />}
                {(this.state.showEditPaymentPass || this.props.forgetPaymentPasswordChangeStatus === true) && <EditPaymentPassword 
                    {...this.props} 
                  backToPersonalDetails={this.toggleShowEditPaymentPass} 
                  toggleShowEditMobileNo={this.toggleShowEditMobileNo}
                />}
                {this.state.showEditLoginPass && <EditLoginPassword 
                  backToPersonalDetails={this.toggleShowEditLoginPass}
                  {...this.props} 
                />}
                {this.state.showEditSecurityAns && <EditSecurityAns backToPersonalDetails={this.toggleShowEditSecurityAns} />}
                {this.state.showAuthenticator && <BindingAuthenticator backToPersonalDetails={this.toggleShowAuthenticator} />}

                <Modal open={this.state.showModal} onClose={this.toggleEditRealNameModal} classNames={{ modal: "pd-edit-modal" }} center>
                    <div className="modal-content edit">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("personal-details.edit")} {t("personal-details.real-name")}</h5>
                        </div>
                        <form
                            className="forms-col needs-validation gap-0"
                            onSubmit={this.props.updateAgentName}
                            noValidate
                            id="edit_real_name_form"
                            name="edit_real_name_form"
                            method="post"
                        >
                            <div className="modal-body">
                                <StringInput
                                    className={`form-control ${this.props.errorMsg.name && "was-validated is-invalid"}`}
                                    // className="form-control"
                                    type="text"
                                    placeholder={t("personal-details.real-name")}
                                    name="realName"
                                    defaultValue=""
                                    value={this.props.personalInfo.real_name}
                                    onChange={(e) => this.props.enterRealName(e)}
                                    autoComplete="off"
                                    // minLength={contact_no_min_limits}
                                    // maxLength={contact_no_max_limits}
                                    // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                                    // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                                    required
                                    requiredMessage={t("validation.required")}
                                    // errorMsg={this.props.errorMsg.mobile_no || ""}
                                    // formError={this.props.formError}
                                />
                            </div>
                            <div class="modal-footer" onClick={this.toggleEditRealNameModal}>
                                <button className={`btn modal-btn-confirm ${this.props.personalInfo.real_name === "" ? `disabled` : ``}`} type="submit" form="edit_real_name_form">
                                {t("global.confirm")}
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal>

                <DateScroller {...this.state} {...this.prop} toggleShowDateSelect={this.toggleShowDateSelect} submitDateSelect={this.props.updatePersonalInfo} onChangeDateHandler={this.props.onChangeDateHandler} maxDate={18} />

                <section className="pd-m-section">
                    <MobileSubHeader className="bg-white" returnPage="/" header={t("personal-details.title")} style={{ justifyContent: "unset" }} />
                    <label className="pd-label-section">{t("page-header.personal-information")}</label>
                    <form className="forms-col needs-validation mb-3" method="post" noValidate>
                        <div className="pd-form-m-col">
                            <div className="input-group-col">
                                <label className="col-form-label">{t("personal-details.username")}</label>
                                <div className="input-group right has-validation">
                                    <p className="form-control lh-lg ">{this.props.personalInfo.name}</p>
                                </div>
                            </div>
                            <div className="input-group-col">
                                <label className="col-form-label">{t("personal-details.real-name")}</label>
                                <div className="input-group right has-validation" onClick={this.props.personalInfo.real_name === "" && this.toggleEditRealNameModal}>
                                    <p className="form-control lh-lg ">{this.props.personalInfo.real_name}</p>
                                    {this.props.personalInfo.real_name === "" && (
                                        <span className="input-group-text">
                                            <Icon icon="uil:angle-right" />
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="input-group-col">
                                <label className="col-form-label">{t("personal-details.mobile-no")}</label>
                                <div className="input-group right has-validation" onClick={this.toggleShowEditMobileNo}>
                                    <p className="form-control lh-lg">{this.props.personalInfo.mobile_no}</p>
                                    <span className="input-group-text">
                                        {this.props.contactVerifiedStatus === 1 && <div className="btn btn-outline-green">{t("personal-details.verify")}</div>}
                                        <Icon icon="uil:angle-right" />
                                    </span>
                                </div>
                            </div>
                            <div className="input-group-col">
                                <label className="col-form-label">{t("personal-details.email")}</label>
                                <div className="input-group right has-validation" onClick={this.toggleShowEditEmailAddress}>
                                    <p className="form-control lh-lg">{this.props.personalInfo.email}</p>
                                    <span className="input-group-text">
                                        {this.props.emailVerifiedStatus === 1 && <div className="btn btn-outline-green">{t("personal-details.verify")}</div>}
                                        <Icon icon="uil:angle-right" />
                                    </span>
                                </div>
                            </div>
                            <div className="input-group-col">
                                <label className="col-form-label">{t("personal-details.birthday")}</label>
                                <div className="input-group right has-validation" onClick={this.props.personalInfo.birthday === null && this.toggleShowDateSelect}>
                                    <p className="form-control lh-lg">{this.props.personalInfo.birthday}</p>

                                    {this.props.personalInfo.birthday === null && (
                                        <span className="input-group-text">
                                            <Icon icon="uil:angle-right" />
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </form>

                    <label className="pd-label-section">{t("personal-details.payment-information")}</label>
                    <form className="forms-col needs-validation mb-3" method="post" noValidate>
                        <div className="pd-form-m-col">
                            <this.securityInfo title={t("personal-details.payment-password")} desc={t("personal-details.remark-payment-password")} onClick={this.toggleShowEditPaymentPass} />
                            <this.securityInfo title={t("personal-details.login-password")} desc={t("personal-details.remark-login-password")} onClick={this.toggleShowEditLoginPass} />
                            {/* <this.securityInfo
                                title="Security Questions"
                                desc="An important basis for retrieving your security information"
                                onClick={this.toggleShowEditSecurityAns}
                            />
                            <this.securityInfo title="Authenticator" desc=" Strengthen the security of account fund withdrawal" onClick={this.toggleShowAuthenticator} /> */}
                        </div>
                    </form>
                    <label className="pd-label-section">{t("personal-details.agent-information")}</label>
                    <form className="forms-col needs-validation mb-3" method="post" noValidate>
                        <div className="pd-form-m-col">
                            <div className="input-group-col">
                                <div className="input-group right has-validation">
                                    <p className="form-control lh-lg text-slate-800">{t("personal-details.subordinate-members")}</p>
                                    <span className="input-group-text">{this.props.subordinateMembers}</span>
                                </div>
                            </div>
                            <div className="input-group-col">
                                <div className="input-group right has-validation">
                                    <p className="form-control lh-lg text-slate-800">{t("personal-details.join-venture-code")}</p>
                                    <span className="input-group-text">{this.props.referralCode}</span>
                                </div>
                            </div>
                            <div className="input-group-col">
                                <div className="input-group right has-validation">
                                    <p className="form-control lh-lg text-slate-800">Downline Agents</p>
                                    <span className="input-group-text">{this.props.downlineAgents}</span>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </>
        );
    }
}

export default withNamespaces()(MobilePersonalDetails);
